import Responsive from './Responsive';
import IScroll from 'iscroll';

class SpNavi{
	constructor(param) {
		this.touches = typeof document.ontouchstart != "undefined",
		this.target = param.target;
		this.trigger = param.trigger;
		this.scroll;
		this.fixer = param.fixer;
	}

	exec(){
		const scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
		const [target,_touches] = [this.target , this.touches];
		let th = 0;

		//set height
		if (this.touches) {
			th = window.innerHeight;
		}else{
			th = $(window).height();
		}

		$(target).height(th).find('#scroller > ul').css({'padding-bottom':this.fixer});//padding-bottomhは環境に合わせて調整

		//set click event
		$(this.trigger).on('click',function(ev){
			ev.preventDefault();
			if($(this).hasClass('active')){
				$(window).off("touchmove._noscroll");
				$(window).off(scroll_event);
				$('.btn_sp_navi_wrap').removeClass('active');
				$(this).removeClass('active');
			}else{
				let Scroll = new IScroll(target, {
					mouseWheel:true,
					preventDefault: false
				});
				if(_touches){
					$(window).on("touchmove._noscroll" , function(event) {
						event.preventDefault();
					});
				}else{
					$(window).on(scroll_event,function(e){e.preventDefault();});
				}
				$('.btn_sp_navi_wrap').addClass('active');
				$(this).addClass('active');
			}
		});

		const r = new Responsive();

		// $(window).on('load resize',function(){
		// 	if(r.state()() === false){
		// 		$(target).hide();
		// 	}
		// });

	}
}
module.exports = SpNavi;



// WEBPACK FOOTER //
// ./dev/js/scripts/SpNavi.js